module.exports = __webpack_public_path__ + "img/main-consign-miniapp.637c272.png";